import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var CompanyNotificationStatus;
(function (CompanyNotificationStatus) {
    CompanyNotificationStatus["ACTIVE"] = "ACTIVE";
    CompanyNotificationStatus["EXPIRED"] = "EXPIRED";
    CompanyNotificationStatus["SCHEDULED"] = "SCHEDULED";
})(CompanyNotificationStatus || (CompanyNotificationStatus = {}));
